exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._22VD0{position:relative!important;text-align:center;transition-duration:.2s;transition-timing-function:ease-out;width:auto;font-size:14px;line-height:18px;font-weight:400;box-shadow:0 3px 9px 3px rgba(0,0,0,.05);text-decoration:none;border:1px solid transparent;float:right;z-index:9}._22VD0,._22VD0:hover{color:#484848!important;background:#fff!important}._22VD0:hover{border-color:transparent!important}._1QA1i{position:fixed!important;right:13px;bottom:13px}._1ve5y{color:#484848;padding-right:5px;padding-bottom:3px;font-size:20px}", ""]);

// exports
exports.locals = {
	"buttonStyle": "_22VD0",
	"buttonPosition": "_1QA1i",
	"iconStyle": "_1ve5y"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/FooterToggle/FooterToggle.css
// module id = 2532
// module chunks = 15